const Consumer = () => import('@/views/main/consumer/consumer/Consumer.vue')
export default {
  path: '/main/consumer/consumer',
  name: 'Consumer',
  component: Consumer,
  children: []
}
